import React, { useState } from "react";
import { Field, Input, Button } from "@fluentui/react-components";
import { Add20Regular, Delete20Regular } from "@fluentui/react-icons";

/**
 * Edit a list of strings. Used for behaviorRules.general, securityRules, examples, etc.
 */
export default function EditableStringList({ label, value, onChange, placeholder, disabled }) {
  const items = Array.isArray(value) ? value : [];
  const [draft, setDraft] = useState("");

  const add = () => {
    const v = draft.trim();
    if (!v) return;
    onChange([...items, v]);
    setDraft("");
  };

  const removeAt = (i) => {
    const next = items.slice();
    next.splice(i, 1);
    onChange(next);
  };

  const updateAt = (i, v) => {
    const next = items.slice();
    next[i] = v;
    onChange(next);
  };

  return (
    <Field label={label} className="field-style">
      <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
        {items.map((item, i) => (
          <div key={i} style={{ display: "flex", gap: 6 }}>
            <Input
              style={{ flex: 1 }}
              value={item}
              onChange={(_, d) => updateAt(i, d.value)}
              disabled={disabled}
            />
            <Button
              appearance="subtle"
              icon={<Delete20Regular />}
              onClick={() => removeAt(i)}
              disabled={disabled}
              aria-label="Remove"
            />
          </div>
        ))}
        <div style={{ display: "flex", gap: 6 }}>
          <Input
            style={{ flex: 1 }}
            value={draft}
            onChange={(_, d) => setDraft(d.value)}
            placeholder={placeholder || "Add item..."}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                e.preventDefault();
                add();
              }
            }}
            disabled={disabled}
          />
          <Button appearance="primary" icon={<Add20Regular />} onClick={add} disabled={disabled || !draft.trim()}>
            Add
          </Button>
        </div>
      </div>
    </Field>
  );
}
